import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import Helmet from 'react-helmet';
import InternetBankingActions from '../../../actions/InternetBankingActions';
import AccountsStore from '../../../stores/AccountsStore';
import AccountsActionCreator from '../../../actions/AccountsActionCreator';
import OrderActionCreator from '../../../actions/OrderActionCreator';
import StatementsPreferencesActionCreator from '../../../actions/StatementsPreferencesActionCreator';
import RenameAccountsActionCreator from '../../../actions/RenameAccountsActionCreator';
import { getNavigationUrl } from '../../../actions/getNavigationUrl';
import { AccountSummary } from './AccountSummary';
import TaggingComponent from './TaggingComponent';
import { FastTrack } from './FastTrack';
import FinancialStoriesComponent from './FinancialStoriesComponent';
import LoaderComponent from '../../common/LoaderComponent';
import { RequiresAuthenticatedUser } from '../../RequiresAuthenticatedUser';
import TransactionsDetailsComponent from './TransactionsDetailsComponent';
import TransactionsActionCreator from '../../../actions/TransactionsActionCreator';
import ManagePaymentActionCreator from '../../../actions/ManagePaymentActionCreator';
import TransactionsStoreNew from '../../../stores/TransactionsStoreNew';
import AccountDetailsBL from './AccountDetailsBL';
import PatternLibModalComponent from './PatternLibModalComponent';
import envConfig from '../../../../static/config';
import AnalyticsActionCreator from '../../../actions/AnalyticsActionCreator';
import config from '../../../config';
import SvgIcon from '../../common/SvgIcon';
import Panel from './Panel';
import {
  saveNavigationReference,
  setSelectedAccountIdForPaymentHistory,
} from '../../../actions/PaymentStatusActionCreator';
import ProjectionStore from '../../../stores/ProjectionStore';
import ProjectionsBL from '../projections/ProjectionsBL';
import FinancialStoriesBL from './FinancialStoriesBL';
import {
  GenericChatComponent,
  getChatContent,
} from '../../common/GenericChatComponent';
import StringConstants from '../../../constants/StringConstants';
import { validNoticeAccountProductCode } from '../../../constants/NoticeAccountsConstants.js';
import {
  TRANSACTIONS_READ,
  INSIGHT_CAROUSEL_VIEW,
} from '../../../constants/AccountCapability';
import UserManagementStore from '../../../stores/UserManagementStore';
import MasterCardAlertActionCreator from '../../../actions/MasterCardAlertActionCreator';
import MasterCardAlertStore from '../../../stores/MasterCardAlertStore';
import BrowserUtils from '../../../utils/BrowserUtils';
import { isBOrVMRetail } from '../../../utils/BrandUtils';
import { setCardManagementBackNavigation } from '../../../utils/CardManagementUtils';
import BusinessPromotionalComponent from './BusinessPromotionalComponent';
import { EnrichedTransactionDetails } from '../EnrichedTransactionDetails';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';

let _selectedTransactionsToTag = [];
let _cssActiveClassForSelectedTags = [];
let _suggestData = '';
const defaultSortField = 'details.when';
const defaultSortOrder = 'desc';
const defaultTypeFilter = 'all';
const accountDetailsCacheTime = 60 * 1000;

let defaultStartDate = moment().subtract(3, 'months');
defaultStartDate = moment(defaultStartDate).startOf('day').toISOString();
let defaultEndDate = moment();
defaultEndDate = moment(defaultEndDate).endOf('day').toISOString();

let accountChangeStartDate = moment().subtract(3, 'months');
accountChangeStartDate = moment(accountChangeStartDate).startOf('day');
let accountChangeEndDate = moment();
accountChangeEndDate = moment(accountChangeEndDate).endOf('day');

let _selectedTransactionsLength = 0;
let changeOfDate = false;
let fromChangeOfDate = false;

const ModalButton = ({ text, onClick }) => (
  <button className="c-btn c-btn--default c-modal__button" onClick={onClick}>
    {text}
  </button>
);

export class AccountDetailsComponent extends React.Component {
  constructor(props) {
    super(props);
    this.onTransactionStoreChange = this.onTransactionStoreChange.bind(this);
    this.onAccountStoreChange = this.onAccountStoreChange.bind(this);
    this.loadNextTransactions = this.loadNextTransactions.bind(this);
    this.tabSelect = this.tabSelect.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.assignTag = this.assignTag.bind(this);
    this.closeSideBar = this.closeSideBar.bind(this);
    this.showSideBarMobile = this.showSideBarMobile.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.getSelectedTypeTransactions =
      this.getSelectedTypeTransactions.bind(this);
    this.onAccountSelect = this.onAccountSelect.bind(this);
    this.onSortChange = this.onSortChange.bind(this);
    this.overlayclick = this.overlayclick.bind(this);
    this.closeErrorPopUp = this.closeErrorPopUp.bind(this);
    this.onRowSelect = this.onRowSelect.bind(this);
    this.deleteTag = this.deleteTag.bind(this);
    this.deleteTagConfirmation = this.deleteTagConfirmation.bind(this);
    this.deleteTagCancellation = this.deleteTagCancellation.bind(this);
    this.mobileSelectionTag = this.mobileSelectionTag.bind(this);
    this.onRowSelectAll = this.onRowSelectAll.bind(this);
    this.onTableTagClick = this.onTableTagClick.bind(this);
    this.taggingComponent = this.taggingComponent.bind(this);
    this.assignedTagModalCheck = this.assignedTagModalCheck.bind(this);
    this.assignedTagErrorModalCheck =
      this.assignedTagErrorModalCheck.bind(this);
    this.onTableTagIconClick = this.onTableTagIconClick.bind(this);
    this.closeTransactionInProgressPopUp =
      this.closeTransactionInProgressPopUp.bind(this);
    this.openTransactionInProgressPopUp =
      this.openTransactionInProgressPopUp.bind(this);
    this.flagForEditTagFunc = this.flagForEditTagFunc.bind(this);
    this.openCloseMore = this.openCloseMore.bind(this);
    this.settingMonthName = this.settingMonthName.bind(this);
    this.settingToDate = this.settingToDate.bind(this);
    this.settingFromDate = this.settingFromDate.bind(this);
    this.onTagInfoClick = this.onTagInfoClick.bind(this);
    this.onTagInfoClickClose = this.onTagInfoClickClose.bind(this);
    this.closeTagErrorPopUp = this.closeTagErrorPopUp.bind(this);
    this.onRetryClick = this.onRetryClick.bind(this);
    this.rememberThisIconClickOpen = this.rememberThisIconClickOpen.bind(this);
    this.rememberThisIconClickClose =
      this.rememberThisIconClickClose.bind(this);
    this.linkClicked = this.linkClicked.bind(this);
    this.updateExportLinkState = this.updateExportLinkState.bind(this);
    this.state = {
      current_device_view: BrowserUtils.getView(),
      sideBarMobile: '',
      account: AccountsStore.getAccount(),
      transactions: TransactionsStoreNew.getTransactions(),
      sidebarFlag: false,
      categoryTags: TransactionsStoreNew.getCategoryTags(),
      customTags: TransactionsStoreNew.getCustomTags(),
      transactionSuggest: TransactionsStoreNew.getSuggestData(),
      isPopUpOpen: false,
      _startDate: moment().subtract(3, 'months'),
      _endDate: moment(),
      showAccountCard: false,
      containerPaddingTop: 0,
      noTagSelection: false,
      _serviceErrorFlag: TransactionsStoreNew.getErrorFlag(),
      deleteTagPopUp: false,
      _deleteTagValue: '',
      showSelectionTag: false,
      accountChangeFlag: false,
      rowCustomClass: '',
      rowClickIndex: -1,
      accountSummaryStyle: {},
      tagsAssignedFlag: false,
      cssActiveClassForSelectedTags: [],
      _transactionsReadFlag: false,
      inProgressTransaction: false,
      flagForEditTag: false,
      openMore: false,
      collapsibleButtonName: 'More',
      iconId: 'icon-down',
      monthName: '3 months',
      accountIdFromStore: AccountsStore.getAccount(),
      tagInfoClickFlag: false,
      changeOfDate: false,
      fromChangeOfDate: false,
      rememberThisIconClick: false,
      accountLoad: AccountsStore.getAccountsLoadedFlag(),
      accountDetailsLoadedAt: null,
      tagsServiceErrorFlag: TransactionsStoreNew.getTagsServiceErrorFlag(),
      transactionServiceErrorFlag:
        TransactionsStoreNew.getTransactionsServiceErrorFlag(),
      otherEventsServiceErrorFlag:
        TransactionsStoreNew.getOtherEventsErrorFlag(),
      tagsErrorMesage: TransactionsStoreNew.getTagsErrorMessage(),
      transactionsErrorMessage:
        TransactionsStoreNew.getTransactionsErrorMessage(),
      statusResponse: TransactionsStoreNew.getStatusResponse(),
      assignTagError: TransactionsStoreNew.getAssignTagError(),
      assignTagErrorMessage: TransactionsStoreNew.getAssignTagErrorMessage(),
      assignedTagName: '',
      assignedTagKey: '',
      accountDetails: AccountsStore.getAccountDetail(
        AccountsStore.getAccount()
      ),
      showTransactionDetails: false,
      cachedScrollYPosition: 0,
      kapitiTransactionsTableHeight: 0,
      selectedTransactionId: null,
    };
  }

  updateExportLinkState() {
    if (BrowserUtils.getView() !== this.state.current_device_view) {
      this.setState({
        current_device_view: BrowserUtils.getView(),
      });
    }
  }

  componentWillMount() {
    if (
      AccountsStore.getAccountDetail(this.state.account).actionsAvailable[
        '/account/transactions/read'
      ]
    ) {
      this.setState({ _transactionsReadFlag: true });
      TransactionsActionCreator.getTransactions(
        this.state.account,
        defaultSortOrder,
        defaultSortField,
        defaultTypeFilter,
        defaultStartDate,
        defaultEndDate
      );
    } else {
      this.setState({ _transactionsReadFlag: false });
    }
  }
  componentDidMount() {
    const accountCardHeight = this.refs['accountCardStick'].offsetHeight;
    this.state.accountCardHeight = accountCardHeight;
    TransactionsStoreNew.addChangeListener(this.onTransactionStoreChange);
    AccountsStore.addChangeListener(this.onAccountStoreChange);
    AnalyticsActionCreator.track(
      {
        path: '/user/experience/view',
        action: 'Appeared',
      },
      {
        description: 'PageLoaded',
      }
    );
    window.addEventListener('resize', this.updateExportLinkState);
  }
  componentWillUnmount() {
    _selectedTransactionsToTag = [];
    _cssActiveClassForSelectedTags = [];
    TransactionsStoreNew.removeChangeListener(this.onTransactionStoreChange);
    AccountsStore.removeChangeListener(this.onAccountStoreChange);
    AccountsStore.clearAccountDetailsIsLoaded(this.state.account);
    document.body.classList.toggle('js-sticky__overflow-hidden', false);
    window.removeEventListener('resize', this.updateExportLinkState);
  }
  onAccountStoreChange() {
    this.setState({
      accountLoad: AccountsStore.getAccountsLoadedFlag(),
      accountDetailsToLoad: false,
    });
  }
  onTransactionStoreChange() {
    this.setState({
      transactions: TransactionsStoreNew.getTransactions(),
      categoryTags: TransactionsStoreNew.getCategoryTags(),
      customTags: TransactionsStoreNew.getCustomTags(),
      transactionSuggest: TransactionsStoreNew.getSuggestData(),
      isPopUpOpen: TransactionsStoreNew.getPopUpFlag(),
      tagsAssignedFlag: TransactionsStoreNew.getTagAssignedFlag(),
      _serviceErrorFlag: TransactionsStoreNew.getErrorFlag(),
      accountIdFromStore: AccountsStore.getAccount(),
      accountDetails: AccountsStore.getAccountDetail(
        AccountsStore.getAccount()
      ),
      tagsServiceErrorFlag: TransactionsStoreNew.getTagsServiceErrorFlag(),
      transactionServiceErrorFlag:
        TransactionsStoreNew.getTransactionsServiceErrorFlag(),
      otherEventsServiceErrorFlag:
        TransactionsStoreNew.getOtherEventsErrorFlag(),
      tagsErrorMesage: TransactionsStoreNew.getTagsErrorMessage(),
      transactionsErrorMessage:
        TransactionsStoreNew.getTransactionsErrorMessage(),
      statusResponse: TransactionsStoreNew.getStatusResponse(),
      assignTagError: TransactionsStoreNew.getAssignTagError(),
      assignTagErrorMessage: TransactionsStoreNew.getAssignTagErrorMessage(),
    });
  }
  onAccountSelect(selectedAccount) {
    if (selectedAccount.id !== this.state.account) {
      _selectedTransactionsToTag = [];
      _cssActiveClassForSelectedTags = [];
      AccountsActionCreator.setAccountID(selectedAccount.id);

      const accountType = AccountsStore.getAccountTypeFromAccountId(
        selectedAccount.id
      );
      const isCreditCard =
        accountType && accountType.toLowerCase() === 'credit_card';

      if (
        selectedAccount.accountDetails === undefined ||
        selectedAccount.accountDetails.error ||
        isCreditCard
      ) {
        AccountsActionCreator.getAccountDetails(selectedAccount.id);
        this.setState({ accountLoad: false, accountDetailsLoadedAt: null });
      }
      this.setState(
        {
          account: selectedAccount.id,
          accountDetailsLoadedAt: null,
          _startDate: accountChangeStartDate,
          _endDate: accountChangeEndDate,
          accountChangeFlag: true,
          sidebarFlag: false,
          tagsAssignedFlag: false,
          isPopUpOpen: false,
          cssActiveClassForSelectedTags: [],
          showSelectionTag: false,
          flagForEditTag: false,
          openMore: false,
          collapsibleButtonName: 'More',
          iconId: 'icon-down',
          monthName: '3 months',
          accountIdFromStore: selectedAccount.id,
          sideBarMobile: '',
          sideNavData: AccountDetailsBL.getSideNavData(selectedAccount.id),
        },
        () => {
          if (
            AccountsStore.getAccountDetail(this.state.account).actionsAvailable[
              TRANSACTIONS_READ
            ]
          ) {
            this.setState({ _transactionsReadFlag: true });
            TransactionsActionCreator.getTransactions(
              selectedAccount.id,
              defaultSortOrder,
              defaultSortField,
              defaultTypeFilter,
              defaultStartDate,
              defaultEndDate
            );
          } else {
            this.setState({ _transactionsReadFlag: false, transactions: [] });
          }
        }
      );
    }
  }
  onSortChange(sortName, sort) {
    const sortOrder = sort;
    let sortField;
    switch (sortName) {
      case 'date':
        sortField = 'details.when';
        break;
      case 'description':
        sortField = 'details.narrative.medium.raw';
        break;
      case 'type':
        sortField = 'details.type';
        break;
      case 'credit':
        sortField = 'details.amount.value';
        break;
      default:
    }
    if (sortName === 'credit' || sortName === 'debit') {
      TransactionsActionCreator.sortSMETransactions(sortName, sort);
    } else if (this.state._transactionsReadFlag) {
      const newStartDate = moment(this.state._startDate)
        .startOf('day')
        .toISOString();
      const newEndDate = moment(this.state._endDate).endOf('day').toISOString();
      !TransactionsStoreNew.getSearchTransactionFlag()
        ? TransactionsActionCreator.getTransactions(
            this.state.account,
            sortOrder,
            sortField,
            TransactionsStoreNew.getTypeFilter(),
            newStartDate,
            newEndDate
          )
        : TransactionsActionCreator.getTransactionSearchData(
            sortOrder,
            sortField,
            TransactionsStoreNew.getTypeFilter(),
            _suggestData,
            newStartDate,
            newEndDate
          );
    }
  }
  onPaySomeoneClick(e) {
    e.preventDefault();
    InternetBankingActions.navigateToWebTask('WEB-OPEN-MOVEMONEY');
  }

  onGivingNoticeClick(e) {
    e.preventDefault();
    InternetBankingActions.navigateToWebTask('WEB-BNA-SECURE-MESSAGE');
  }

  onTableTagClick(row) {
    this.onRowSelect(row, true);
    this.setState({
      sidebarFlag: !this.state.sidebarFlag,
      tagsServiceErrorFlag: TransactionsStoreNew.getTagsServiceErrorFlag(),
    });
  }
  onTableTagIconClick() {
    this.setState({
      sidebarFlag: !this.state.sidebarFlag,
      tagsServiceErrorFlag: TransactionsStoreNew.getTagsServiceErrorFlag(),
    });
  }
  onMoreDetailsClick = ({ rowClickIndex, selectedTransactionId }) => {
    // `rowClickIndex` is used only for the desktop rows, don't ask why - Griddle magic
    this.setState({
      ...(rowClickIndex && { rowClickIndex }),
      selectedTransactionId,
      cachedScrollYPosition: window.scrollY,
      kapitiTransactionsTableHeight:
        this.refs.kapitiTransactionsTableRef?.clientHeight,
    });

    this.toggleTransactionDetails();
  };
  onRowClick(row) {
    if (!this.state.sidebarFlag) {
      const index = row instanceof Object ? row.props.rowIndex : row;
      if (this.state.rowClickIndex === index) {
        this.setState({
          rowCustomClass:
            this.state.rowCustomClass === 'row-open' ? '' : 'row-open',
        });
      } else {
        this.setState({ rowCustomClass: 'row-open' });
      }
      this.setState({ rowClickIndex: index });
    }
  }
  onRowSelect(row, isSelected) {
    _cssActiveClassForSelectedTags = this.state.cssActiveClassForSelectedTags;
    if (isSelected) {
      _.findIndex(_selectedTransactionsToTag, row.id) < 0 &&
        _selectedTransactionsToTag.push(row.id);
      _.findIndex(_cssActiveClassForSelectedTags, row.id) < 0 &&
        _cssActiveClassForSelectedTags.push(row.tagId.toString());
    } else {
      _selectedTransactionsToTag = _.pull(_selectedTransactionsToTag, row.id);
      _cssActiveClassForSelectedTags = _.pull(
        _cssActiveClassForSelectedTags,
        row.tagId.toString()
      );
    }
    this.setState({
      sidebarFlag: this.state.sidebarFlag,
      cssActiveClassForSelectedTags: _cssActiveClassForSelectedTags,
    });
  }
  onRowSelectAll(row, isSelected) {
    if (isSelected) {
      _selectedTransactionsToTag = [];
      _cssActiveClassForSelectedTags = [];
      _.map(row, (rowData) => {
        _selectedTransactionsToTag.push(rowData.id);
        if (!(_.isNull(rowData.tagId) || _.isUndefined(rowData.tagId))) {
          _cssActiveClassForSelectedTags.push(rowData.tagId.toString());
        }
      });
      this.setState({
        cssActiveClassForSelectedTags: _cssActiveClassForSelectedTags,
      });
    } else {
      _selectedTransactionsToTag = [];
      _cssActiveClassForSelectedTags = [];
      this.setState({
        cssActiveClassForSelectedTags: _cssActiveClassForSelectedTags,
      });
    }
  }
  closeSideBar() {
    _selectedTransactionsToTag = [];
    _cssActiveClassForSelectedTags = [];
    this.setState({
      sidebarFlag: false,
      cssActiveClassForSelectedTags: _cssActiveClassForSelectedTags,
      showSelectionTag: false,
    });
  }
  showSideBarMobile(show) {
    if (show) {
      this.setState({
        sideBarMobile: ' account-details__sidebar--is-animating-left',
      });
    } else {
      this.setState({
        sideBarMobile: ' account-details__sidebar--is-animating-right',
      });
    }
    document.body.classList.toggle('js-sticky__overflow-hidden', show);
    this.refs['overlay'].classList.toggle('overlay__show', show);
  }
  getSelectedTypeTransactions(data) {
    _suggestData = data;
    const newStartDate = moment(this.state._startDate)
      .startOf('day')
      .toISOString();
    const newEndDate = moment(this.state._endDate).endOf('day').toISOString();
    this.setState({ isPopUpOpen: false }, () => {
      TransactionsActionCreator.getTransactionSearchData(
        TransactionsStoreNew.getSortOrder(),
        TransactionsStoreNew.getSortField(),
        TransactionsStoreNew.getTypeFilter(),
        _suggestData,
        newStartDate,
        newEndDate
      );
    });
  }
  onDateChange(startDate, endDate) {
    const newStartDate = moment(startDate).startOf('day').toISOString();
    const newEndDate = moment(endDate).endOf('day').toISOString();
    _selectedTransactionsToTag = [];
    _cssActiveClassForSelectedTags = [];
    this.setState(
      {
        _startDate: startDate,
        _endDate: endDate,
        accountChangeFlag: false,
        changeOfDate: false,
        cssActiveClassForSelectedTags: _cssActiveClassForSelectedTags,
      },
      () => {
        if (this.state._transactionsReadFlag) {
          fromChangeOfDate = false;
          changeOfDate = false;
          !TransactionsStoreNew.getSearchTransactionFlag()
            ? TransactionsActionCreator.getTransactions(
                this.state.account,
                TransactionsStoreNew.getSortOrder(),
                TransactionsStoreNew.getSortField(),
                TransactionsStoreNew.getTypeFilter(),
                newStartDate,
                newEndDate
              )
            : TransactionsActionCreator.getTransactionSearchData(
                TransactionsStoreNew.getSortOrder(),
                TransactionsStoreNew.getSortField(),
                TransactionsStoreNew.getTypeFilter(),
                _suggestData,
                newStartDate,
                newEndDate
              );
        }
      }
    );
  }
  assignTag(e) {
    if (_selectedTransactionsToTag.length > 0) {
      _selectedTransactionsToTag = _.uniq(_selectedTransactionsToTag);
      TransactionsActionCreator.tagSelectedTransactions(
        _selectedTransactionsToTag,
        e,
        this.state.account
      );
      _selectedTransactionsLength = _selectedTransactionsToTag.length;
      _selectedTransactionsToTag = [];
      _cssActiveClassForSelectedTags = [];
      this.setState({
        assignedTagName: e.value,
        assignedTagKey: e.key,
        sidebarFlag: false,
        showSelectionTag: false,
        cssActiveClassForSelectedTags: _cssActiveClassForSelectedTags,
      });
    }
  }
  loadNextTransactions() {
    const newStartDate = moment(this.state._startDate)
      .startOf('day')
      .toISOString();
    const newEndDate = moment(this.state._endDate).endOf('day').toISOString();
    if (!TransactionsStoreNew.getSearchTransactionFlag()) {
      TransactionsActionCreator.getTransactions(
        this.state.account,
        TransactionsStoreNew.getSortOrder(),
        TransactionsStoreNew.getSortField(),
        TransactionsStoreNew.getTypeFilter(),
        newStartDate,
        newEndDate
      );
    } else {
      TransactionsActionCreator.getTransactionSearchData(
        TransactionsStoreNew.getSortOrder(),
        TransactionsStoreNew.getSortField(),
        TransactionsStoreNew.getTypeFilter(),
        _suggestData,
        newStartDate,
        newEndDate
      );
    }
  }
  tabSelect(key) {
    /**
     * Block app from inflating the `from` request parameter
     * in case when user selects the same "typeFilter"
     */
    if (key === TransactionsStoreNew.getTypeFilter()) {
      return;
    }

    TransactionsActionCreator.setApplyFilterStatus(false);
    _selectedTransactionsToTag = [];
    _cssActiveClassForSelectedTags = [];
    this.setState(
      { cssActiveClassForSelectedTags: _cssActiveClassForSelectedTags },
      () => {
        if (this.state._transactionsReadFlag) {
          const newStartDate = moment(this.state._startDate)
            .startOf('day')
            .toISOString();
          const newEndDate = moment(this.state._endDate)
            .endOf('day')
            .toISOString();
          !TransactionsStoreNew.getSearchTransactionFlag() &&
          this.state._transactionsReadFlag
            ? TransactionsActionCreator.getTransactions(
                this.state.account,
                TransactionsStoreNew.getSortOrder(),
                TransactionsStoreNew.getSortField(),
                key,
                newStartDate,
                newEndDate
              )
            : TransactionsActionCreator.getTransactionSearchData(
                TransactionsStoreNew.getSortOrder(),
                TransactionsStoreNew.getSortField(),
                key,
                _suggestData,
                newStartDate,
                newEndDate
              );
        }
      }
    );
  }
  overlayclick() {
    this.showSideBarMobile(false);
  }
  closeErrorPopUp() {
    this.setState({ transactionServiceErrorFlag: false });
  }
  deleteTag(e) {
    this.setState({ deleteTagPopUp: true, _deleteTagValue: e });
  }
  deleteTagConfirmation() {
    AnalyticsActionCreator.track(
      {
        path: '/user/experience/activity',
        action: 'Interacted',
      },
      {
        description: config.analytics.analytics_action_tag_editor_archive_tag,
        event: 'click',
      }
    );
    TransactionsActionCreator.deleteTag(this.state._deleteTagValue);
    this.setState({ deleteTagPopUp: false, flagForEditTag: false });
  }
  deleteTagCancellation() {
    this.setState({
      deleteTagPopUp: false,
      _deleteTagValue: '',
      flagForEditTag: true,
    });
  }
  linkClicked(e, id) {
    e.preventDefault();
    // eslint-disable-next-line default-case
    switch (id) {
      case 'payment':
        ManagePaymentActionCreator.saveNavigationReference(
          StringConstants.WEB_ACCOUNT_DETAILS
        );
        InternetBankingActions.navigateToWebTask('WEB-MANAGE-PAYMENT');
        break;
      case 'paymentStatus':
        setSelectedAccountIdForPaymentHistory(this.state.account);
        saveNavigationReference('WEB-ACCOUNT-DETAILS');
        InternetBankingActions.navigateToWebTask('WEB-MANAGE-PAYMENT-STATUS');
        break;
      case 'alerts':
        MasterCardAlertStore.setNavigation(StringConstants.WEB_ACCOUNT_DETAILS);
        MasterCardAlertActionCreator.setManageAlertsAccountID(
          AccountsStore.getAccount()
        );
        InternetBankingActions.navigateToWebTask(
          StringConstants.WEB_MASTERCARD_ALERTS
        );
        break;
      case 'renameAccount':
        RenameAccountsActionCreator.setSelectedAccountID(
          AccountsStore.getAccount()
        );
        RenameAccountsActionCreator.setBackPageReference(
          StringConstants.WEB_ACCOUNT_DETAILS
        );
        InternetBankingActions.navigateToWebTask('WEB-RENAME-ACCOUNT');
        break;
      case 'documentLib':
        RenameAccountsActionCreator.setSelectedAccountID(
          AccountsStore.getAccount()
        );
        RenameAccountsActionCreator.setBackPageReference(
          StringConstants.WEB_ACCOUNT_DETAILS
        );
        InternetBankingActions.navigateToWebTask('WEB-DOCUMENT-LIBRARY');
        break;
      case 'statements': {
        InternetBankingActions.navigateToWebTask('WEB-DIGITAL-STATEMENTS');
        StatementsPreferencesActionCreator.setBackPageReference(
          'WEB-DIGITAL-STATEMENTS'
        );
        getNavigationUrl(StringConstants.WEB_ACCOUNT_DETAILS);
        break;
      }
      case 'orderStatement':
        OrderActionCreator.getStatementOrderData({
          orderType: 'orderStatement',
          navigation: StringConstants.WEB_ACCOUNT_DETAILS,
          accountId: AccountsStore.getAccount(),
          bankId: envConfig.brandId,
        });
        InternetBankingActions.navigateToWebTask('WEB-ORDER-STATEMENT');
        break;
      case 'orderCheque':
        OrderActionCreator.getStatementOrderData({
          orderType: 'orderCheque',
          navigation: StringConstants.WEB_ACCOUNT_DETAILS,
          accountId: AccountsStore.getAccount(),
          bankId: envConfig.brandId,
        });
        InternetBankingActions.navigateToWebTask('WEB-ORDER-CHEQUE');
        break;
      case 'orderPayin':
        OrderActionCreator.getStatementOrderData({
          orderType: 'orderPayin',
          navigation: StringConstants.WEB_ACCOUNT_DETAILS,
          accountId: AccountsStore.getAccount(),
          bankId: envConfig.brandId,
        });
        InternetBankingActions.navigateToWebTask('WEB-ORDER-PAY-IN');
        break;
      case 'exportTransaction':
        InternetBankingActions.navigateToWebTask(
          StringConstants.WEB_EXPORT_TRANSACTION
        );
        break;
      case 'manageDebitCards':
      case 'manageCard':
        setCardManagementBackNavigation(StringConstants.WEB_ACCOUNT_DETAILS);
        InternetBankingActions.navigateToWebTask(
          StringConstants.WEB_MANAGE_CARDS
        );
        break;
      case 'manageInsurance':
        InternetBankingActions.navigateToWebTask('WEB-MANAGE-INSURANCE');
        break;
      case 'privateBankingBenefits':
        InternetBankingActions.navigateToWebTask(
          'WEB-PRIVATE-ACOOUNT-BENEFITS'
        );
        break;
      case 'currentAccountTracker':
        InternetBankingActions.navigateToWebTask(
          'WEB-CURRENT-TRACKER-BENEFITS'
        );
    }
  }
  mobileSelectionTag() {
    this.setState({
      showSelectionTag: !this.state.showSelectionTag,
    });
  }
  assignedTagModalCheck() {
    this.setState({ tagsAssignedFlag: false, assignTagError: false });
  }
  assignedTagErrorModalCheck() {
    this.setState({ tagsAssignedFlag: false, assignTagError: false });
    this.loadNextTransactions();
  }
  taggingComponent() {}
  closeTransactionInProgressPopUp() {
    this.setState({ inProgressTransaction: false });
  }
  openTransactionInProgressPopUp() {
    this.setState({ inProgressTransaction: true });
  }
  getProjectionStatus() {
    ProjectionStore.setAccountId(this.state.account);
    const projectionStatus = ProjectionStore.getStatusOfId(this.state.account);
    const projectionData = ProjectionStore.getDataOfId(this.state.account);
    const projectionErrorObj = ProjectionStore.getErrorObjOfId(
      this.state.account
    );
    const titleMessages = ProjectionsBL.getTileMessages(
      projectionStatus,
      projectionData,
      projectionErrorObj,
      this.props.content
    );
    return titleMessages;
  }
  flagForEditTagFunc(editTagFlagValue) {
    this.setState({ flagForEditTag: editTagFlagValue });
  }
  openCloseMore() {
    const { account, accountDetailsLoadedAt } = this.state;

    this.setState({ openMore: !this.state.openMore }, () => {
      if (this.state.openMore) {
        this.setState({ collapsibleButtonName: 'Hide', iconId: 'icon-up' });

        let accountDetailsLoadedTimeDiff = 0;
        let accountDetailsToLoad = false;

        if (
          accountDetailsLoadedAt !== null &&
          accountDetailsLoadedAt.isValid()
        ) {
          accountDetailsLoadedTimeDiff = moment().diff(accountDetailsLoadedAt);
        }

        if (
          accountDetailsLoadedAt === null ||
          accountDetailsLoadedTimeDiff > accountDetailsCacheTime
        ) {
          accountDetailsToLoad = true;
        } else {
          accountDetailsToLoad = false;
        }
        this.setState({ accountDetailsToLoad });

        if (accountDetailsToLoad) {
          AccountsStore.clearAccountDetailsIsLoaded(this.state.account);
          AccountsActionCreator.getAccountDetails(account);
          this.setState({ accountDetailsLoadedAt: moment() });
        }
      } else {
        this.setState({ collapsibleButtonName: 'More', iconId: 'icon-down' });
      }
    });
  }
  settingMonthName(_monthName) {
    this.setState({ monthName: _monthName });
  }
  settingToDate(toDate) {
    if (
      fromChangeOfDate ||
      moment(this.state._endDate).startOf('day').toISOString() !==
        moment(toDate).startOf('day').toISOString()
    ) {
      changeOfDate = true;
      this.setState({ _endDate: toDate, changeOfDate: true });
    } else {
      changeOfDate = false;
      this.setState({ changeOfDate: false });
    }
  }
  settingFromDate(fromDate) {
    if (this.state._startDate !== fromDate) {
      fromChangeOfDate = true;
      this.setState({ _startDate: fromDate, changeOfDate: true });
    } else {
      fromChangeOfDate = false;
      this.setState({ changeOfDate: false });
    }
  }
  onTagInfoClick() {
    this.setState({ tagInfoClickFlag: true });
  }
  onTagInfoClickClose() {
    this.setState({ tagInfoClickFlag: false });
  }
  closeTagErrorPopUp() {
    this.setState({ tagsServiceErrorFlag: false });
  }
  onRetryClick() {
    this.setState({ transactionServiceErrorFlag: false });
    const newStartDate = moment(this.state._startDate)
      .startOf('day')
      .toISOString();
    const newEndDate = moment(this.state._endDate).endOf('day').toISOString();
    if (!TransactionsStoreNew.getSearchTransactionFlag()) {
      TransactionsActionCreator.getTransactions(
        this.state.account,
        TransactionsStoreNew.getSortOrder(),
        TransactionsStoreNew.getSortField(),
        TransactionsStoreNew.getTypeFilter(),
        newStartDate,
        newEndDate
      );
    } else {
      TransactionsActionCreator.getTransactionSearchData(
        TransactionsStoreNew.getSortOrder(),
        TransactionsStoreNew.getSortField(),
        TransactionsStoreNew.getTypeFilter(),
        _suggestData,
        newStartDate,
        newEndDate
      );
    }
  }
  rememberThisIconClickOpen() {
    this.setState({ rememberThisIconClick: true });
  }
  rememberThisIconClickClose() {
    this.setState({ rememberThisIconClick: false });
  }
  toggleTransactionDetails = () => {
    this.setState(
      (prevState) => ({
        showTransactionDetails: !prevState.showTransactionDetails,
      }),
      () => {
        /**
         * Restore scroll position when going back
         * to the parent (`AccountDetailsComponent`) page
         */
        if (!this.state.showTransactionDetails) {
          window.scrollTo(
            0,
            this.state.cachedScrollYPosition -
              this.state.kapitiTransactionsTableHeight
          );
        }
      }
    );
  };
  render() {
    const {
      account,
      cssActiveClassForSelectedTags,
      transactionServiceErrorFlag,
      deleteTagPopUp,
      tagsAssignedFlag,
      inProgressTransaction,
      tagInfoClickFlag,
      assignedTagName,
      assignedTagKey,
      sidebarFlag,
      transactionsErrorMessage,
      assignTagError,
      assignTagErrorMessage,
      rememberThisIconClick,
      tagsServiceErrorFlag,
      accountSummaryStyle,
      tagsErrorMesage,
      accountLoad,
      accountChangeFlag,
      openMore,
      collapsibleButtonName,
      iconId,
      sideBarMobile,
      _transactionsReadFlag,
      transactions,
      transactionSuggest,
      isPopUpOpen,
      showSelectionTag,
      _startDate,
      _endDate,
      rowCustomClass,
      rowClickIndex,
      monthName,
      accountIdFromStore,
      statusResponse,
      categoryTags,
      customTags,
      flagForEditTag,
      containerPaddingTop,
      accountDetails,
      showTransactionDetails,
      selectedTransactionId,
    } = this.state;
    const accDetails = AccountsStore.getAccountDetail(account);
    let errorModal;
    let deleteTagModal;
    let assignedTagModal;
    const { type } = AccountsStore.getAccountDetail(account);
    const sideBarData = AccountDetailsBL.getSideNavData(account);
    const loadTransactions = TransactionsStoreNew.getLoadTransactions();
    const noTagSelection = _selectedTransactionsToTag.length > 0 ? false : true;
    const transactionServiceErrorMessage = transactionServiceErrorFlag
      ? _.get(transactionsErrorMessage, 'error.message')
      : '';
    const productCode = accountDetails.product.code;
    const isNoticeAccount = validNoticeAccountProductCode.includes(productCode);
    const isCorporateAdmin = UserManagementStore.isCorporateAdmin();

    if (deleteTagPopUp) {
      let modalFooter = (
        <div>
          <button
            onClick={this.deleteTagCancellation}
            className="c-btn c-btn--secondary"
          >
            Cancel
          </button>
          &nbsp;
          <button
            onClick={this.deleteTagConfirmation}
            className="c-btn c-btn--default"
          >
            Yes
          </button>
        </div>
      );
      deleteTagModal = (
        <PatternLibModalComponent
          show={deleteTagPopUp}
          onHide={this.deleteTagCancellation}
          bsSize="medium"
          modalHeading="Delete Tag"
          modalBody="You'll still be able to see it on your transactions, but you won't be able to use it in the future. Still happy to delete?"
          modalFooter={modalFooter}
          customClass="c-modal"
        />
      );
    }
    if (tagsAssignedFlag) {
      const usingVerb =
        _selectedTransactionsLength === 1
          ? 'transaction has'
          : 'transactions have';
      let modalBodyData = `${_selectedTransactionsLength} ${usingVerb} been retagged ${assignedTagName}`;
      if (assignedTagKey === '784904') {
        modalBodyData = `${_selectedTransactionsLength} ${usingVerb} been untagged`;
      }
      assignedTagModal = (
        <PatternLibModalComponent
          show={tagsAssignedFlag}
          onHide={this.assignedTagModalCheck}
          bsSize="medium"
          modalHeading={
            <SvgIcon
              className="center-block account-success"
              id="icon-success"
              width="64px"
              height="64px"
            />
          }
          modalBody={modalBodyData}
          modalFooter=""
          customClass="c-modal c-modal--center c-modal--account-details-flag"
          closeButton={false}
          timeOut={tagsAssignedFlag}
          assignedTagModalCheck={this.assignedTagModalCheck}
        />
      );
    }
    if (assignTagError) {
      assignedTagModal = (
        <PatternLibModalComponent
          show={assignTagError}
          onHide={this.assignedTagErrorModalCheck}
          bsSize="medium"
          modalHeading=""
          modalBody={`${assignTagErrorMessage.error.message}`}
          modalFooter={
            <ModalButton text="OK" onClick={this.assignedTagErrorModalCheck} />
          }
          customClass="c-modal c-modal--account-details-flag"
          timeOut={tagsAssignedFlag}
          assignedTagModalCheck={this.assignedTagErrorModalCheck}
        />
      );
    }
    if (inProgressTransaction) {
      errorModal = (
        <PatternLibModalComponent
          show={inProgressTransaction}
          onHide={this.closeTransactionInProgressPopUp}
          bsSize="medium"
          modalHeading="In progress"
          modalBody="This is still going through"
          modalFooter={
            <ModalButton
              text="OK"
              onClick={this.closeTransactionInProgressPopUp}
            />
          }
          customClass="c-modal c-modal--account-details-flag"
        />
      );
    }
    if (rememberThisIconClick) {
      errorModal = (
        <PatternLibModalComponent
          show={rememberThisIconClick}
          onHide={this.rememberThisIconClickClose}
          bsSize="medium"
          modalHeading="FYI"
          modalBody="'Remember this' enables you to tag every transaction like this in the future."
          modalFooter={
            <ModalButton text="OK" onClick={this.rememberThisIconClickClose} />
          }
          customClass="c-modal c-modal--account-details-flag"
        />
      );
    }

    if (sidebarFlag && tagsServiceErrorFlag) {
      errorModal = (
        <PatternLibModalComponent
          show={tagsServiceErrorFlag}
          onHide={this.closeTagErrorPopUp}
          bsSize="medium"
          modalHeading=""
          modalBody={`${tagsErrorMesage.error.message}`}
          modalFooter={
            <ModalButton text="OK" onClick={this.closeTagErrorPopUp} />
          }
          customClass="c-modal c-modal--account-details-flag"
        />
      );
    }
    const isTaggingEnabled = isBOrVMRetail() && sidebarFlag;
    const isFinancialStoriesEnabled =
      isBOrVMRetail() && FinancialStoriesBL.getTiles(accDetails).length > 0;
    const isBusinessInsightCarouselEnabled =
      isCorporateAdmin &&
      type === 'current' &&
      accDetails.actionsAvailable[INSIGHT_CAROUSEL_VIEW];

    if (showTransactionDetails) {
      return (
        <EnrichedTransactionDetails
          {...this.props}
          data={transactions.find(
            (transaction) => transaction.id === selectedTransactionId
          )}
          handleBackButton={this.toggleTransactionDetails}
        />
      );
    }

    return (
      <div className="bow page">
        <Helmet title="Account View" />
        <div className="account-details">
          <div
            ref="accountCardStick"
            className="container"
            style={accountSummaryStyle}
            id="site-main"
            tabIndex="-1"
          >
            <div className="row">
              <div className="col-md1-18 col-sm1-21 col-xs1-20">
                {accountLoad ? (
                  <AccountSummary
                    accountId={account}
                    onAccountSelect={this.onAccountSelect}
                    openMore={openMore}
                    openCloseMore={this.openCloseMore}
                    collapsibleButtonName={collapsibleButtonName}
                    iconId={iconId}
                    content={this.props.content}
                  />
                ) : (
                  <LoaderComponent type="small" />
                )}
              </div>
              <div className="col-xs1-4 col-sm1-3  col-md1-6 fastract-wrap">
                {sideBarData && <FastTrack onClick={this.showSideBarMobile} />}
              </div>
            </div>
          </div>
          <div
            ref="childContainer"
            className="container"
            style={{ paddingTop: containerPaddingTop }}
          >
            <section className="row">
              <div className="col-xs1-24 col-md1-18">
                {UserManagementStore.isAdditionalUser() &&
                !_transactionsReadFlag ? (
                  <div className="c-field c-field--error">
                    <div className="c-field__controls ">
                      <div
                        role="alert"
                        id="refErr"
                        className="c-field__message"
                      >
                        <p>
                          <strong>Permission Required</strong> <br /> To view
                          financial details for this account, you'll need to
                          contact your corporate administrator.
                        </p>
                      </div>
                    </div>
                  </div>
                ) : (
                  <TransactionsDetailsComponent
                    {...this.props}
                    account={account}
                    accountType={AccountsStore.getAccountTypeFromAccountId(
                      account
                    )}
                    accDetails={accDetails}
                    transactionReadFlag={_transactionsReadFlag}
                    selectedRowIds={_selectedTransactionsToTag}
                    transactions={transactions}
                    loadNextTransactions={this.loadNextTransactions}
                    onSort={this.onSortChange}
                    loadTransactionsFlag={loadTransactions}
                    isLoading={TransactionsStoreNew.getLoader()}
                    showMoreLoaderFlag={TransactionsStoreNew.getShowMoreLoader()}
                    tabSelect={this.tabSelect}
                    onRowClick={this.onRowClick}
                    isMultipleSelection={sidebarFlag}
                    onRowSelect={this.onRowSelect}
                    onRowSelectAll={this.onRowSelectAll}
                    suggestData={transactionSuggest}
                    isPopUpOpen={isPopUpOpen}
                    getSelectedTypeTransactions={
                      this.getSelectedTypeTransactions
                    }
                    onDateChange={this.onDateChange}
                    showSelectionTag={showSelectionTag}
                    mobileSelectionTag={this.mobileSelectionTag}
                    startDate={_startDate}
                    endDate={_endDate}
                    accountChangeFlag={accountChangeFlag}
                    rowCustomClass={rowCustomClass}
                    rowClickIndex={rowClickIndex}
                    onTableTagClick={this.onTableTagClick}
                    onTableTagIconClick={this.onTableTagIconClick}
                    onMoreDetailsClick={this.onMoreDetailsClick}
                    openTransactionInProgressPopUp={
                      this.openTransactionInProgressPopUp
                    }
                    monthName={monthName}
                    settingMonthName={this.settingMonthName}
                    accountIdFromStore={accountIdFromStore}
                    settingToDate={this.settingToDate}
                    settingFromDate={this.settingFromDate}
                    transactionServiceErrorFlag={transactionServiceErrorFlag}
                    transactionServiceErrorMessage={
                      transactionServiceErrorMessage
                    }
                    statusErrorResponse={statusResponse}
                    onRetryClick={this.onRetryClick}
                    changeOfDate={changeOfDate}
                    fromChangeOfDate={fromChangeOfDate}
                    isAccountPool={false}
                    kapitiTransactionsTableRef={(element) =>
                      (this.refs.kapitiTransactionsTableRef = element)
                    }
                  />
                )}

                {isFinancialStoriesEnabled && (
                  <FinancialStoriesComponent
                    {...this.props}
                    account={account}
                    tileData={this.getProjectionStatus()}
                  />
                )}
                {isBusinessInsightCarouselEnabled && (
                  <BusinessPromotionalComponent
                    {...this.props}
                    accountDetails={accountDetails}
                  />
                )}
              </div>
              <div className="col-md1-6">
                <div
                  ref="overlay"
                  className="c-overlay overlay__hidden@Desktop"
                  onClick={this.overlayclick}
                />
                {isNoticeAccount && isCorporateAdmin && (
                  <NavigationButton.Secondary
                    onClick={this.onGivingNoticeClick}
                    labelText="Withdraw your money"
                    data-test-id="navigation-give-notice"
                  />
                )}
                {AccountsStore.getPaymentsFlag() && !isNoticeAccount && (
                  <NavigationButton.Secondary
                    onClick={this.onPaySomeoneClick}
                    labelText="Pay or transfer money"
                    data-test-id="navigation-pay-money"
                  />
                )}
                {sideBarData.length && (
                  <Panel
                    className={` account-details__sidebar account-details__sidebar@tablet account-details__sidebar--is-animating ${sideBarMobile}`}
                    type={type}
                    SideBarlist={sideBarData}
                    linkClicked={this.linkClicked}
                    showSideBarMobile={this.showSideBarMobile}
                    sideBarButtons={''}
                  />
                )}{' '}
                {/* This should not be inside the Panel and we can have pay or transfer on top as getSideNavData() can return 0 for some case eg BOW4071 */}
                {UserManagementStore.isBusinessUser() && (
                  <div className="account-details__chat">
                    <GenericChatComponent
                      content={getChatContent(this.props.content)}
                    />
                  </div>
                )}
              </div>
            </section>
            {isTaggingEnabled && (
              <TaggingComponent
                {...this.props}
                selectedTransactionsToTag={_selectedTransactionsToTag}
                sidebarOpen={sidebarFlag}
                categoryTags={categoryTags}
                customTags={customTags}
                assignTag={this.assignTag}
                unTagSelected={this.assignTag}
                closeSideBar={this.closeSideBar}
                untaggedObj={TransactionsStoreNew.getUntagged()}
                deleteTag={this.deleteTag}
                noTagSelection={noTagSelection}
                cssActiveClassForSelectedTags={cssActiveClassForSelectedTags}
                flagForEditTag={flagForEditTag}
                flagForEditTagFunc={this.flagForEditTagFunc}
                onTagInfoClick={this.onTagInfoClick}
                rememberThisIconClick={rememberThisIconClick}
                rememberThisIconClickOpen={this.rememberThisIconClickOpen}
                rememberThisIconClickClose={this.rememberThisIconClickClose}
              />
            )}
          </div>
          {errorModal}
          {deleteTagModal}
          {assignedTagModal}
          {tagInfoClickFlag && (
            <PatternLibModalComponent
              show={tagInfoClickFlag}
              onHide={this.onTagInfoClickClose}
              bsSize="medium"
              modalHeading="Tags"
              modalBody="Now choose one of the Tags from this list or tap on My Tags to create one of your own (you can have up to 5)."
              modalFooter={
                <ModalButton text="OK" onClick={this.onTagInfoClickClose} />
              }
              customClass="c-modal c-modal--account-details-flag"
            />
          )}
        </div>
      </div>
    );
  }
}

export default RequiresAuthenticatedUser(AccountDetailsComponent);
